import styled from 'styled-components';
import { tokens } from '../design/tokens';

export const FiltersBar = styled.div`
  display: flex;
  gap: ${tokens.spacing.md};
  margin-bottom: ${tokens.spacing.lg};
  align-items: center;
  flex-wrap: wrap;
`;

export const FilterSelect = styled.select`
  padding: ${tokens.spacing.sm} ${tokens.spacing.md};
  border: 1px solid ${tokens.colors.adminBorder};
  border-radius: 6px;
  background: ${tokens.colors.adminSurface};
  color: ${tokens.colors.adminText};
  font-size: 14px;
  min-width: 150px;
`;

export const DataTable = styled.div`
  background: ${tokens.colors.adminSurface};
  border-radius: 8px;
  overflow-x: auto;
  border: 1px solid ${tokens.colors.adminBorder};
  -webkit-overflow-scrolling: touch;
`;

export const TableHeader = styled.div`
  background: #f8f9fa;
  padding: ${tokens.spacing.md} ${tokens.spacing.xl};
  border-bottom: 1px solid ${tokens.colors.adminBorder};
  display: grid;
  grid-template-columns: minmax(300px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr) 120px;
  gap: ${tokens.spacing.md};
  font-weight: 600;
  color: ${tokens.colors.adminText};
  min-width: 700px;

  @media (max-width: 1024px) {
    grid-template-columns: minmax(250px, 2fr) minmax(100px, 1fr) minmax(100px, 1fr) 100px;
    min-width: 600px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 2fr 1fr 1fr 100px;
    min-width: 500px;
    padding: ${tokens.spacing.sm} ${tokens.spacing.md};
  }
`;

export const TableRow = styled.div`
  padding: ${tokens.spacing.md} ${tokens.spacing.xl};
  border-bottom: 1px solid ${tokens.colors.adminBorder};
  display: grid;
  grid-template-columns: minmax(300px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr) 120px;
  gap: ${tokens.spacing.md};
  align-items: center;
  transition: background 0.2s;
  min-width: 700px;

  &:hover {
    background: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 1024px) {
    grid-template-columns: minmax(250px, 2fr) minmax(100px, 1fr) minmax(100px, 1fr) 100px;
    min-width: 600px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 2fr 1fr 1fr 100px;
    min-width: 500px;
    padding: ${tokens.spacing.sm} ${tokens.spacing.md};
  }
`;

export const TableCell = styled.div`
  color: ${tokens.colors.adminText};
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:first-child {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: ${tokens.spacing.sm};
  flex-wrap: wrap;
`;

export const ActionBtn = styled.button<{ $variant?: 'edit' | 'delete' }>`
  padding: ${tokens.spacing.xs} ${tokens.spacing.sm};
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.xs}; 
  transition: all 0.2s;
  min-width: 32px;
  justify-content: center;

  ${props => {
        if (props.$variant === 'delete') {
            return `
        background: #fee2e2;
        color: #dc2626;
        &:hover { background: #fecaca; }
      `;
        }
        return `
      background: #d1fae5;
      color: #16a34a;
      &:hover { background: #a7f3d0; }
    `;
    }}

  @media (max-width: 768px) {
    padding: ${tokens.spacing.xs};
    font-size: 11px;
  }
`;
